import { getRequestConfig } from 'api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SaveEmailTemplatePayload } from 'Interfaces/EmailTemplateInterface';
import { addEmailTempate, loadedEmailTemplates, removeEmailTemplate } from 'reducers/emailTemplates';

export const getEmailTemplates = createAsyncThunk(
  'emailTemplates/load',
  async (args, thunkApi) => {
    const config = getRequestConfig();
    const data = await fetch('/json/gmail/template', config).then(r => r.json());
    if (Array.isArray(data)) {
      thunkApi.dispatch(loadedEmailTemplates(data));
      return data;
    }
    return [];
  }
);

export const createEmailTemplate = createAsyncThunk(
  'emailTemplates/create',
  async (payload: SaveEmailTemplatePayload, thunkApi) => {
    const config = getRequestConfig();
    const data = await fetch('/json/gmail/template', {
      ...config,
      method: 'POST',
      headers: { ...config.headers, 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(r => r.json());
    if (data && data.id) {
      thunkApi.dispatch(addEmailTempate(data));
      return data;
    }
    return [];
  }
);

export const deleteEmailTemplate = createAsyncThunk(
  'emailTemplates/delete',
  async (id: number, thunkApi) => {
    const config = getRequestConfig();
    const response = await fetch(`/json/gmail/template/${encodeURIComponent(id)}`, {
      ...config,
      method: 'DELETE',
    }).then(r => r.json());
    // const data = await fetch('/json/emailTemplates', config).then(r => r.json());
    if (response.status === 'OK') {
      thunkApi.dispatch(removeEmailTemplate(id));
    }
    return [];
  }
);
